fourToldApp.controller("userCntrl", function($http, $scope, services, $mdMedia, $cookieStore, $cookies, $interval, $rootScope, esb, $timeout, $route, $window) {
	$scope.user = {};
	$scope.user = services.user.getData();

	var oriPerson = angular.copy($scope.register);
	$scope.invalid;
	var self = this;
    self.activated = true;
    self.determinateValue = 0;

    var now = new $window.Date(),
		exp = new $window.Date(now.getFullYear(), now.getMonth()+6, now.getDate());

    $interval(function() {
    	self.determinateValue += 1;
    }, 10, 0, true);

	$scope.$watch(function () {
			return window.localStorage.getItem('userData');
		},function(newVal,oldVal){
			$scope.user = services.user.getData();
		}
	)

	$scope.$watch(function () {
			return window.localStorage.getItem('userPhoto');
		},function(newVal,oldVal){

			if($scope.user) {
				$cookieStore.put('id_lender', $scope.user.entity.id, {
					expires: exp
				});
			}
		}
	)

	$scope.uploadPhoto = function(file){
		$scope.play = undefined;
	    var f = document.getElementById('file').files[0];
	    var r = new FileReader();
	    r.onloadend = function(e){
	      var data = e.target.result;
	      //send your binary data via $http or $resource or do anything else with it
	    }
	    r.readAsBinaryString(f);
	    var fd = new FormData();
	    fd.append("file", document.getElementById('file').files[0]);
	    services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).updatePhoto({}, fd, function(response, event){
		    $scope.play = "ok";

		    $timeout(function(){
			    services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).userPhoto({}, function(response){
				        services.user.setPhoto(response.data);
				        $scope.toast('Your new profile image has been saved', 1);
		      			$scope.resetForm();
			      }, function(response){});
		    }, 1200);
	    }, function(error) {

		}
	)}

    $scope.uploadLogo = function(file){

        $scope.play = undefined;
        var f = document.getElementById('file').files[0];
        var r = new FileReader();
        r.onloadend = function(e){
            var data = e.target.result;
            //send your binary data via $http or $resource or do anything else with it
        }
        r.readAsBinaryString(f);

        var fd = new FormData();
        //Take the first selected file
        fd.append("file", document.getElementById('file').files[0]);
        services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).updatePhoto({}, fd, function(response, event){
                $scope.play = "ok";

                $timeout(function(){
                    services.user.userServices('bearer '+$window.localStorage.getItem('access_token1')).userPhoto({}, function(response){
                        services.user.setLogo(response.data);
                        $scope.toast('Your new Logo has been saved', 1);
                        $scope.resetForm();
                    }, function(response){});
                }, 1200);
            }, function(error) {

            }
        )}

	$scope.upload = function(){
		$scope.play = undefined;
	}

	$scope.toast = function(messenger, id){
		toastr.options.closeDuration = 500;
        if(id==0){
        	toastr.error(messenger);
        	$scope.error=true;
        }else if(id == 1){
        	toastr.success(messenger);
        	$scope.success=true;
        }
	}

	$scope.passwordChange = function(oldPassword, newPassword){
		$scope.send = "ok";
		$scope.invalid = undefined;
   		services.update_password('bearer '+$window.localStorage.getItem('access_token1')).password({oldPassword: oldPassword, newPassword: newPassword}, function(response){
	      $scope.send = undefined;
	      if(response.code == -24){
	      	$scope.invalid = "yes";
	      	$scope.toast('Invalid Password', 0);
	      }else {
	      	$scope.toast('Your new password has been saved', 1);
	      	$scope.resetForm();
	      }

    	}, function(error){

    	});
    }

     $scope.resetForm = function(){

    	$scope.register = angular.copy(oriPerson);
     	$scope.profileUpdate.$setPristine();
    }

    $scope.changeStatus = function(newStatus){
    //$scope.user.status=newStatus;
    services.user.setData($scope.user);
        if (newStatus==1){
            $http.put(esb+"lender/enable",null,{
                   headers: {'Authorization': 'bearer '+$window.localStorage.getItem('access_token1')}
            });
        }else{
            $http.put(esb+"lender/disable",null,{
                   headers: {'Authorization': 'bearer '+$window.localStorage.getItem('access_token1')}
            });
        }
    }
});
